import { FC } from "react";

interface PointToPointIconSVGProps {
    className?: string;
}

const PointToPointIconSVG: FC<PointToPointIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.5 34.8337C16.5 37.8712 14.0376 40.3337 11 40.3337C7.96243 40.3337 5.5 37.8712 5.5 34.8337C5.5 31.7961 7.96243 29.3337 11 29.3337C14.0376 29.3337 16.5 31.7961 16.5 34.8337ZM16.5 34.8337H32.0833C33.7851 34.8337 35.4172 34.1576 36.6206 32.9543C37.824 31.7509 38.5 30.1188 38.5 28.417C38.5 26.7152 37.824 25.0831 36.6206 23.8797C35.4172 22.6764 33.7851 22.0003 32.0833 22.0003H11.9167C10.2149 22.0003 8.58276 21.3243 7.3794 20.1209C6.17604 18.9176 5.5 17.2855 5.5 15.5837C5.5 13.8819 6.17604 12.2497 7.3794 11.0464C8.58276 9.84303 10.2149 9.16699 11.9167 9.16699H27.5M27.5 9.16699C27.5 12.2046 29.9624 14.667 33 14.667C36.0376 14.667 38.5 12.2046 38.5 9.16699C38.5 6.12943 36.0376 3.66699 33 3.66699C29.9624 3.66699 27.5 6.12943 27.5 9.16699Z"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PointToPointIconSVG;
